import admin from './admin';

const whatsappApi = {
  admin,
};

export default whatsappApi;
